import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/cotizaciones/detalle/{id}", "documento": "quotation", "acceso": "sesion", "filas": ["089"], "cita": "Areas/Quotation/Controllers/QuotationController.cs"} satisfies RutaProd;
